// src/components/ui/Pagination.jsx
// Paginación simple "Anterior / n de m / Siguiente" con rango de registros.
import { ChevronLeft, ChevronRight } from "lucide-react";

const btn =
  "flex items-center gap-1 px-3 py-1.5 text-xs font-medium border border-gray-300 rounded-lg text-gray-600 hover:bg-gray-50 disabled:opacity-40 disabled:pointer-events-none transition-colors";

const Pagination = ({ page, pageSize, total, onPageChange }) => {
  const totalPages = Math.max(1, Math.ceil(total / pageSize));
  const desde = total === 0 ? 0 : (page - 1) * pageSize + 1;
  const hasta = Math.min(page * pageSize, total);

  return (
    <div className="flex flex-col sm:flex-row items-center justify-between gap-2 text-sm text-gray-600">
      <span className="text-xs text-gray-400">
        {total === 0 ? "0" : `${desde}–${hasta}`} de {total}
      </span>
      <div className="flex items-center gap-2">
        <button
          type="button"
          onClick={() => onPageChange(Math.max(1, page - 1))}
          disabled={page <= 1}
          className={btn}
        >
          <ChevronLeft className="h-3.5 w-3.5" /> Anterior
        </button>
        <span className="px-2.5 py-1 bg-gray-100 rounded-md text-xs font-medium">
          {page} / {totalPages}
        </span>
        <button
          type="button"
          onClick={() => onPageChange(Math.min(totalPages, page + 1))}
          disabled={page >= totalPages}
          className={btn}
        >
          Siguiente <ChevronRight className="h-3.5 w-3.5" />
        </button>
      </div>
    </div>
  );
};

export default Pagination;
